import * as React from 'react';

import { ResultItem } from 'apis/ReportApi';

import 'components/GMetrixProgressBar/GMetrixProgressBar.scss';

type GMetrixProgressBarProps = {
    className?: string;
    dataItem: ResultItem;
};

export const GMetrixProgressBar = (props: GMetrixProgressBarProps) => {

    const { className, dataItem } = props;

    const makePercentage = (share: number): number => {

        if (share > 100) {

            return makePercentage(share / 10);

        }

        return Math.ceil(share);

    };

    const percentage = makePercentage(Number(dataItem.Share));

    // percentage is already 0–100, so clamp and map it directly to the fill width
    const widthPct = Math.min(percentage, 100);

    return (
        <div className={`mt-2 mb-2 ${className ?? ''}`} style={{ width: '100%' }} title={dataItem.Title}>
            {dataItem.Title ? (
                <b>
                    {dataItem.Title}
                </b>
            ) : null}
            <div
                style={{
                    backgroundColor: '#e9ecef',
                    borderRadius: '0.25rem',
                    height: '1rem',
                    overflow: 'hidden',
                    position: 'relative',
                    width: '100%'
                }}
            >
                <div
                    aria-valuemax={100}
                    aria-valuemin={0}
                    aria-valuenow={percentage}
                    role="progressbar"
                    style={{ background: dataItem.Color, height: '100%', width: `${widthPct}%` }}
                />
                <span
                    style={{
                        alignItems: 'center',
                        color: '#fff',
                        display: 'flex',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        inset: 0,
                        justifyContent: 'center',
                        pointerEvents: 'none',
                        position: 'absolute',
                        textShadow: '0 0 3px rgba(0,0,0,0.8), 0 0 6px rgba(0,0,0,0.6)'
                    }}
                >
                    {percentage}
                    %
                </span>
            </div>
        </div>
    );

};
